import React, { useState } from "react";
import { Button, Modal, TimePicker, Row, Col, Divider, Form } from "antd";
import { observer } from "mobx-react-lite";
//import moment from "moment";
import { useStore } from "../../../../app/stores/store";
import { useShiftCode } from "../../../../app/hooks/useShiftCode";

const CustomTimePickerBtn = observer(({ 
  day, 
  checkboxState, 
  onTimeChange 
}) => {
  const { count } = useShiftCode({
    pageNumber: 0,
    pageSize: 9999,
  });
  
  const { timeStore } = useStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [timeIn, setTimeIn] = useState(null);
  const [timeOut, setTimeOut] = useState(null);
  const [isTimeIn, setIsTimeIn] = useState(true);

  const showModal = () => {
    // Initialize with current time when opening modal
    //const now = moment();
    setTimeIn(null);
    setTimeOut(null);
    setIsTimeIn(true);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsTimeIn(true);
  };

  const handleTimeChange = (time) => {
    if (!time) return;

    if (isTimeIn) {
      setTimeIn(time);
    } else {
      setTimeOut(time);
    }
  };

  const handleNextClick = () => {
    if (!timeIn) return;
    setIsTimeIn(false);
    setTimeOut(null);
    timeStore.setDefaultCode(count);
  };

  const handleSaveClick = () => {
    if (!timeIn || !timeOut) return;

    const formattedTimeIn = timeIn.format("hh:mm A");
    const formattedTimeOut = timeOut.format("hh:mm A");

    timeStore.setCustomTime(
      day,
      formattedTimeIn,
      formattedTimeOut,
      checkboxState
    );

    if (onTimeChange) {
      onTimeChange(formattedTimeIn, formattedTimeOut);
    }

    setIsModalOpen(false);
    setIsTimeIn(true);
  };

  return (
    <>
      {timeStore.customName && (
        <Button
          onClick={showModal}
          style={{
            backgroundColor: "transparent",
            borderColor: "transparent",
            color: "#ff7201",
            height: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "none",
            fontSize: "30px",
          }}
        >
          +
        </Button>
      )}

      <Modal
        footer={null}
        closable={false}
        style={{ top: 300 }}
        width={300}
        open={isModalOpen}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col>
            <h3>
              SET <span style={{ color: "#FF7201" }}>TIME</span>
            </h3>
          </Col>
          <Divider />
          <Col style={{ marginBottom: "50px" }}>
            <h2>{isTimeIn ? "Time In" : "Time Out"}</h2>
            <TimePicker
              use12Hours
              format="hh:mm A"
              onChange={handleTimeChange}
              value={isTimeIn ? timeIn : timeOut}
              //defaultValue={moment()} // Set default to current time
              style={{
                height: "60px",
                width: "200px",
                borderLeft: "none",
                borderRight: "none",
                borderColor: "black",
                borderRadius: 0,
              }}
            />
          </Col>
          <Form.Item>
            <Row gutter={20} justify="center" style={{ marginTop: 20 }}>
              {isTimeIn ? (
                <Col>
                  <Button
                    type="primary"
                    onClick={handleNextClick}
                    disabled={!timeIn}
                    style={{
                      backgroundColor: "#F47F20",
                      borderRadius: "83px",
                      width: "100px",
                    }}
                  >
                    Next
                  </Button>
                </Col>
              ) : (
                <Col>
                  <Button
                    type="primary"
                    onClick={handleSaveClick}
                    disabled={!timeOut}
                    style={{
                      backgroundColor: "#F47F20",
                      borderRadius: "83px",
                      width: "100px",
                    }}
                  >
                    Save
                  </Button>
                </Col>
              )}
              <Col>
                <Button
                  type="default"
                  onClick={handleCancel}
                  style={{
                    backgroundColor: "#2C2C2C",
                    borderRadius: "83px",
                    width: "100px",
                    color: "#fff",
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Row>
      </Modal>
    </>
  );
});

export default CustomTimePickerBtn;